import React from 'react';

/** The order status changes the order webhook will push (planned). */
const ORDER_EVENTS = [
  'OPEN',
  'PREPARING',
  'READY_TO_PICKUP',
  'SHIPPED',
  'CANCELLED',
];

/**
 * Webhooks for warehouse orders (`POST /v1/integration/outbound-orders`) —
 * their own endpoint, separate from the shipment one (own URL and secret,
 * one per environment). Not available yet: the section says what is coming
 * and how to follow an order meanwhile, with no way to register an endpoint.
 */
const OrderWebhooksSection: React.FC = () => (
  <section
    aria-labelledby="order-webhooks-title"
    className="rounded-2xl border border-stroke-soft-200 bg-bg-white-0 p-6"
  >
    <div className="flex flex-wrap items-start justify-between gap-3">
      <div>
        <h2
          id="order-webhooks-title"
          className="flex items-center gap-2 text-base font-semibold text-text-strong-950"
        >
          Webhooks · Outbound order
          <span className="rounded-full bg-bg-weak-50 px-2 py-0.5 text-[11px] font-semibold text-text-sub-600">
            Coming soon
          </span>
        </h2>
        <p className="mt-0.5 max-w-xl text-xs text-text-sub-600">
          For warehouse orders you create with{' '}
          <code className="font-mono">
            POST /v1/integration/outbound-orders
          </code>
          : Dash will push each order status change, with the order as it stood
          at that moment, to an endpoint of its own — separate from your
          shipment endpoint, with its own URL and secret.
        </p>
      </div>
    </div>

    <div className="mt-4 flex items-start gap-2.5 rounded-lg bg-information-lighter px-4 py-3 text-xs text-information-dark">
      <i className="ri-time-line mt-px text-sm" />
      <span>
        <b>Not available yet.</b> Until it is, read an order with{' '}
        <code className="font-mono">
          GET /v1/integration/outbound-orders/:id
        </code>{' '}
        to follow it. Once it ships, its shipment sends your{' '}
        <b>shipment webhooks</b> above, with{' '}
        <code className="font-mono">bookingId</code> = your{' '}
        <code className="font-mono">externalID</code>.
      </span>
    </div>

    <div className="mt-5">
      <p className="text-xs font-semibold uppercase tracking-wide text-text-soft-400">
        Events it will send
      </p>
      <div className="mt-2 flex flex-wrap gap-1.5">
        {ORDER_EVENTS.map((e) => (
          <code
            key={e}
            className="rounded-md bg-bg-weak-50 px-2 py-0.5 font-mono text-xs text-text-sub-600"
          >
            {e}
          </code>
        ))}
      </div>
    </div>
  </section>
);

export default OrderWebhooksSection;
